export default "__VITE_ASSET__BC1m0fsM__"